import { Field } from 'formik';
import CreatableSelect from 'react-select/creatable';
import ElementInstructions from '../components/ElementInstructions';
import ElementHeading from '../components/ElementHeading';
import ElementErrorMessage from './ElementErrorMessage';
import { RiSearchLine } from 'react-icons/ri';
import {
  handleChange,
  handleInputChange,
  init,
  isMulti,
} from './utils';
import InputWrapper from '../components/InputWrapper';

const BLACK = '#333333';
const GRAY = '#C4C4C4';
const GRAY_1 = '#EDF2F7';
const GRAY_2 = '#989898';
const NAVY = '#2542BB';
/*
const BLACKER = '#29292A';
const ORANGE = '#FF914D';
const RED = '#FF0000 ';
*/
/// STILL TO STYLE:
///   position dropdown,
/// change border to GRAY
/// width of background to hug text of input - setting width to 'auto' does not work

const DropdownIndicator = ({ innerRef, innerProps }) => {
  return (
    <RiSearchLine
      ref={innerRef}
      {...innerProps}
      sx={{ padding: '8px', color: 'red' }}
    />
  );
};

const adSelStyles = {
  control: provided => ({
    ...provided,
    borderColor: GRAY,
    borderRadius: '4px',
  }),

  // clearIndicator: () => ({
  //   display: 'none',
  // }),

  //     MAY HELP POSITION DROPDOWN
  // container: (provided, state) => ({
  //   ...provided,
  // }),

  indicatorsContainer: provided => ({
    ...provided,
    margin: '8px',
    color: GRAY_2,
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  input: provided => ({
    ...provided,
    color: 'black',
    fontWeight: 600,
    textTransform: 'uppercase',
    paddingLeft: '4px',
  }),

  /// selected value for single value
  singleValue: (provided) => ({
    ...provided,
    display: 'flex',
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: NAVY,
    borderRadius: '4px',
    textTransform: 'uppercase',
    alignText: 'center',
    padding: '4px 8px',
    ':hover': {
      backgroundColor: GRAY,
    },
  }),

  ///selected values display for isMultiple
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: NAVY,
    borderRadius: '4px',
    textTransform: 'uppercase',
    alignText: 'center',
    padding: '4px 8px',
    ':hover': {
      backgroundColor: GRAY,
    },
  }),

  // multiValueRemove: () => ({
  //   display: 'none',
  // }),

  option: () => ({
    fontFamily: 'Work Sans',
    color: BLACK,
    fontWeight: 600,
    textTransform: 'uppercase',
    padding: '10px 12px',
    margin: '6px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: GRAY_1,
      borderRadius: '4px',
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: 1,
  }),
};

const AdvancedSelect = ({ fieldName, qObj, props, index }) => {
  const sectionData = props.stateProps.sectionData;
  index = sectionData.sectionName === 'resumes' ? index : sectionData.sectionIndex;
  if (typeof qObj === 'undefined' || qObj === null || typeof qObj.options === 'undefined' || qObj.options === null) {
    return null;
  } else {
    let isMultiple = isMulti(qObj);
    let placeholder = 'Select one';
    if (qObj.qid === 'industry') {
      qObj.options = qObj.indOptions;
      placeholder = 'Select an Industry';
    }
    return (
      <Field name={fieldName}>
        {({ field, form }) => {
          const selected = init(qObj, field);
          return (
            <>
              <ElementHeading qObj={qObj} props={props} />
              <ElementInstructions instructions={qObj.instructions} />
              <InputWrapper>
                <CreatableSelect
                  sx={{ minWidth: '100%', maxWidth: '1000px' }}
                  createOptionPosition="first"
                  placeholder={placeholder}
                  isMulti={isMultiple}
                  closeMenuOnSelect
                  formatCreateLabel={() => ''}
                  onChange={e => handleChange(e, props, qObj, index)}
                  onInputChange={e =>handleInputChange({ DropdownIndicator },adSelStyles)}
                  options={qObj.options}
                  value={selected}
                  components={{ DropdownIndicator }}
                  styles={adSelStyles}
                />
              </InputWrapper>
              <ElementErrorMessage props={props} qid={qObj.qid} />
            </>
          );
        }}
      </Field>
    );
  }
};
export default AdvancedSelect;
